// extracted by mini-css-extract-plugin
module.exports = {"placeholder-timeslot":"PlaceholderTimeslot_placeholder-timeslot___90Qq"};